// @flow

import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { toastr } from "react-redux-toastr";
import Select from "react-select";
import styles from "./createCategory.scss";
import InputField from "../../../../commons/formElements/inputField/inputField";
import { createCategorySubmit } from "../categorySettingsRedux/categorySettingsActionCreator";
import { isNullOrEmptyString } from "../../../../../services/helpers";

type Props = {
  categorySettingsState: Object,
  onBack: Function,
  categoryData?: Object,
  createCategorySubmit: Function,
  userProfile: Object
};

type State = {
  name: string,
  locationType: string
};

const options = [
  { value: "HQTR", label: "HQTR" },
  { value: "OU", label: "OU" }
];

class CreateCategory extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = {
      name: this.props.categoryData ? this.props.categoryData.name : "",
      locationType: this.props.categoryData
        ? this.props.categoryData.locationType
        : ""
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.categorySettingsState.category.isLoading &&
      nextProps.categorySettingsState.category.isLoaded &&
      nextProps.categorySettingsState.category.data
    ) {
      if (this.props.categoryData) {
        toastr.success("Category edited successfully");
      } else {
        toastr.success("Category created successfully");
      }
      this.props.onBack();
    } else if (this.props.categoryData && !nextProps.categoryData) {
      this.setState({
        name: "",
        locationType: ""
      });
    }
  }

  onSubmit() {
    if (isNullOrEmptyString(this.state.name)) {
      toastr.error("Please enter category name");
      return;
    }
    if (isNullOrEmptyString(this.state.locationType)) {
      toastr.error("Please select location type");
      return;
    }
    const formData = {
      businessUnitId: this.props.userProfile.business_unit.id,
      locationType: this.state.locationType,
      name: this.state.name,
      id: this.props.categoryData ? this.props.categoryData.id : null,
      isActive: this.props.categoryData
        ? this.props.categoryData.isActive
        : null
    };
    this.props.createCategorySubmit(formData, this.props.categoryData);
  }

  handleBack() {
    this.props.onBack();
  }

  renderCategoryNameInput() {
    return (
      <div>
        <div className={`${styles.utilityBar}`}>
          <h2>Category Name*</h2>
        </div>
        <div className={`${styles.utilityBar}`}>
          <InputField
            onChange={text =>
              this.setState({
                name: text
              })
            }
            value={this.state.name}
          />
          <div className={`${styles.helpText}`}>eg: Delivery, POD, etc</div>
        </div>
      </div>
    );
  }

  renderCategoryLocationTypeInput() {
    return (
      <div>
        <div className={`${styles.utilityBar}`}>
          <h2>Types of facility types where the category can be present*</h2>
        </div>
        <div className={`${styles.select}`}>
          <Select
            onBlurResetsInput={false}
            onSelectResetsInput={false}
            autoFocus
            options={options}
            simpleValue
            clearable={true}
            name="selected-state"
            disabled={false}
            value={this.state.locationType}
            onChange={newValue =>
              this.setState({
                locationType: newValue
              })
            }
            searchable={true}
          />
        </div>
      </div>
    );
  }

  renderSubmitButton() {
    return (
      <div>
        <div className={`${styles.buttonGroup} l-row`}>
          <div
            className={`${styles.btnBackWrapper} l-row a-center`}
            onClick={() => this.handleBack()}
          >
            <div>
              <div className={`${styles.btnBackTextWrapper} j-center a-center`}>
                Back
              </div>
            </div>
          </div>
          <div
            className={`${styles.btnWrapper} l-row a-center`}
            onClick={() => this.onSubmit()}
          >
            <div>
              <div className={`${styles.btnTextWrapper} j-center a-center`}>
                Submit
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className={styles.createCategoryWrapper}>
        <div className={`${styles.utilityBar}`}>
          <h1>Make Category</h1>
        </div>
        {this.renderCategoryNameInput()}
        {this.renderCategoryLocationTypeInput()}
        {this.renderSubmitButton()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  categorySettingsState: state.categorySettingsState,
  userProfile: state.userProfile
});

const mapDispatchToProps = dispatch => ({
  createCategorySubmit: bindActionCreators(createCategorySubmit, dispatch)
});

CreateCategory.defaultProps = {
  categoryData: null
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateCategory);



// WEBPACK FOOTER //
// ./app/components/containers/ticketing/categorySettings/createCategory/createCategory.js